import { TextField } from "@mui/material";
import { useState } from "react";
import { DynamicFormControl } from "../../../";
import { getLocalizedStringMethods, localizeText, useTranslateDetection } from "../../helpers/translate-helper";
import { LocalizedStringsMethods } from "react-localization";
// import InputMask from 'react-input-mask';
const InputMask = require('react-input-mask');

function PhoneControl(props: DynamicFormControl) {
    const [value, setValue] = useState(props.value ?? '');

    const { currentLanguage } = useTranslateDetection();
    let strings: LocalizedStringsMethods | null = getLocalizedStringMethods(props, currentLanguage);
    let label = props.label;

    if (strings != null && label != null) {
        const localization = localizeText(strings, label);
        label = localization.localization;
    }

    const handleChange = (event: any) => {
        const value = event.target.value as string;

        if (props.setState) {
            props.setState(value);
        }
        setValue(value);
    };

    if (props.updater != null) {
        props.updater.setValue = value => {
            setValue(value ?? '');
        };
    }

    // CKM 2/2022 - Very odd bug. If you use the word "Phone" in the label for the masked control, chrome autofill will cause the app to break
    // Using the &shy; HTML character here in between the 'P' and 'h' in "Phone" in order to break the word up appears to fix the issue, albeit an odd workaround.
    // https://stackoverflow.com/questions/26972529/is-there-a-html-character-that-is-blank-including-no-whitespace-on-all-browser
    const labelString = props?.label?.replace('Phone', 'P­hone');

    return (
        <InputMask value={value} onChange={handleChange} mask="(999) 999-9999" maskPlaceholder=" " disabled={props.disabled}>
            {() =>
                <TextField
                    type="text"
                    autoComplete={props.autoComplete}
                    autoFocus={props.autoFocus}
                    fullWidth={props.fullWidth}
                    disabled={props.disabled}
                    id={props.id}
                    name={props.name}
                    placeholder={props.placeholder}
                    required={props.required}
                    rows={props.rows}
                    maxRows={props.rowsMax}
                    size={props.size}
                    label={labelString}
                    key={label}
                />}
        </InputMask>
    )
}


export default PhoneControl;